import * as React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { clone, cloneDeep, isEqual } from "lodash";
import Autocomplete from '@mui/material/Autocomplete';
import { FormLabel, FormControl, FormGroup, FormHelperText, Popper } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import { getValueAtPath } from "~common/form/helper";
import * as request from 'superagent';
import { Theme, StyleRules, ClassNameMap } from '@mui/styles';
import { useState } from 'react';
import Renderers from '~common/lib/renderers';
import Poptart from '~common/components/poptart';



// TODO: Check out limitTags being dynamic?

// Helper functions that do not need access to state defined here. 
function appendToQuery(props) {
  var append = '';
  if (props.appendToQuery && props.appendToQuery.length > 0) {
    props.appendToQuery.forEach((q: any) => {
      if (q.key && q.value) {
        append += `&${q.key}=${q.value}`;
      }
    });
  }
  return append;
};

function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}

function fetchSuggestions(props: any, query: string, probe: boolean) {
  var queryValid = false
  var minQueryChars = props.fieldDefinition.minQueryChars
  let asUrl = props.fieldDefinition.autoSuggestURL
  if (props.autoSuggestUrl) {
    asUrl = props.autoSuggestUrl
  }
  if (asUrl && asUrl != "") {


    if (probe || (minQueryChars && query.length >= minQueryChars)) {
      queryValid = true
    } else if (!minQueryChars && query.length >= 2) {
      queryValid = true
    }
    if (queryValid) {

      let queryText: string = query;
      const suggestRequest = { queryText: query };

      let attrname = "?query="
      if (props.fieldDefinition.autoSuggestURL.indexOf("?") > -1) {
        attrname = "&query="
      }

      var url = asUrl +
        attrname +
        (query || '') +
        appendToQuery(props);


      return new Promise(function (resolve, reject) {
        request
          .get(url)
          .then((response) => {
            if (response.statusCode == 200) {
              if (response.body) {
                const limited = response.body.reduce((acc, item) => {
                  if (!props.excluded || props.excluded.length == 0) {
                    acc.push(item);
                  } else {
                    const ex = props.excluded.find((xItem) => {
                      return (
                        // Exsclude the item if
                        // If the excluded value matches the suggested value exactly
                        item.value == xItem.value ||
                        // If the excluded item key matches the suggested item (for string-back values like features
                        item.value == xItem.value.key ||
                        // If the suggestion has and ID and that value matches the excluded ID
                        (item.value.id && item.value.id === xItem.value.id)
                      );
                    });
                    // If not excluded, add it the the list.
                    if (!ex || ex.length == 0) {
                      acc.push(item);
                    }
                  }
                  return acc;
                }, []);
                resolve(limited);
              } else {
                resolve([])
              }
            } else {
              reject(response.body);
            }
          })
          .catch((err: any) => {
            // Rather than rejecting the promise, we resolve it with an empty array.  This will prevent the component from throwing uncaught errors.
            //reject(err);
            resolve([]);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  } else {
    return new Promise((resolve, reject) => {
      resolve(props.fieldDefinition.options);
    });
  }
};

function unwrapSuggestions(suggestions) {
  var unwrapped = [];
  if (suggestions) {
    suggestions.forEach((s: any) => {
      unwrapped.push(s);
    })
  }
    return unwrapped;

};

function unwrapValues(values) {
  var unwrapped = [];

  values.forEach((s: any) => {
    unwrapped.push(s.value);
  })

  return unwrapped;
};
function filterConditionalOptions(options, props) {
  var { onAccessRootData, data } = props;

  if (options && options.length > 0) {
    options = options.filter((o: any) => {
      if (!o.conditions || o.conditions.length == 0) {
        return o;
      }
      if (o.conditions && o.conditions.length > 0) {
      
        var conditionResults = o.conditions.map((c: any) => {
          if (c.path.indexOf("~") != 0) {
            // Does not equal
            if (String(c.value).startsWith("!")) {
              var evalValue = String(c.value).substring(1)
              if (String(getValueAtPath(c.path, data || {})) != evalValue) {
                return true
              }
              // Equals
            } else {
              if (getValueAtPath(c.path, data || {}) == c.value) {
                return true
              }
            }

          } else {
            if (onAccessRootData) {
              // Does not equal
              if (String(c.value).startsWith("!")) {
                var evalValue = String(c.value).substring(1)
                if (String(onAccessRootData(c.path)) != evalValue) {
                  return true
                }
                // Equals
              } else {
                if (onAccessRootData(c.path) == c.value) {
                  return true
                }
              }

            }
          }
          return false
        });

        // At this point the results from each conditional evaluation are in an array.  We need to evaluate the array based on the conditional operator.
        var conditionalOperator =  "or";
        if(props.fieldDefinition && o.conditionalOperator) {
          conditionalOperator = o.conditionalOperator
        }

        switch(conditionalOperator.toLowerCase()) {
          case "and":
            if (conditionResults.every(Boolean)) {
              return o;
            }
            break;
          default:
            if (conditionResults.some(Boolean)) {
              return o;
            }
            break;
        }

      }
    });
  }
  return options;
};
// Desired hook
function useCompare(val) {

  const prevVal = usePrevious(val)
  return prevVal !== val
}

// Helper hook
function usePrevious(value) {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}



export default function AutocompleteField(props) {
  // Initial Defitions, setting up the options, type, and state. 
  const { classes }: { classes: ClassNameMap } = props;
  var initialOptions = []
  if (props.fieldDefinition && props.fieldDefinition.options) {
    initialOptions = filterConditionalOptions(props.fieldDefinition.options, props)
  }

  // This is used to highlight when using the filter button
  const sectionContainerRef = React.createRef(null);

  // initValue is not a default value, rather it is a value to be set pre-component did mount. It is defined here so that it can be conditionally changed based on type, to fit in with what MUIAutocomplete expects, either a value or an array (for multiples)
  var initValue = null
  const [probeValid, setProbeValid] = useState(false);
  const [chipFilterElement, setChipFilterElement] = useState(null);

  const highlight = (evt:any) => {
    var chips = sectionContainerRef.current.getElementsByClassName("MuiChip-label")
    for (var i = 0; i < chips.length; i++) {
      if (evt.target.value.length > 0 && chips[i].innerText.toLowerCase().indexOf(evt.target.value.toLowerCase()) > -1){
        chips[i].innerHTML = "<span class='highlighted' style='opacity:1'>" +chips[i].innerText + "</span>"
      } else if (evt.target.value.length == 0) {
        chips[i].innerHTML = "<span class='highlighted' style='opacity:1'>" +chips[i].innerText + "</span>"
      } else {
        chips[i].innerHTML = "<span class='blured' style='opacity: .3'>" +chips[i].innerText + "</span>"
      }
    
    }
  }


  var fieldType = "SimpleSelect"
  if (props.type && props.type == "Relation") {
    if (probeValid) {
      fieldType = "RelationStatic"
    } else {
      fieldType = "Relation"
    }
  } else if (props.type && props.type == "RelationList") {
    if (probeValid) {
      fieldType = "RelationListStatic"
    } else {
      fieldType = "RelationList"
    }

    initValue = []
  } else if (props.fieldDefinition && props.fieldDefinition.allowsMultiples) {
    fieldType = "MultiSelect"
    initValue = []
  }

  const [options, setOptions] = useState(initialOptions);
  const [open, setOpen] = useState(false);
  const [inputVal, setInputVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(initValue);
  const [asUrl, setasUrl] = useState(props.autoSuggestURL);

  // Functions that are called in the render or elsewhere
  const onListDelete = (label) => () => {
    if (value) {
      var newVals = value.filter((v) => v.label !== label)
      onChangeHandleToParent(newVals)
      setValue((value) => value.filter((v) => v.label !== label));

    }
  };

  // Called when the inner TextField Component has a change, which in this case will trigger an API search. 
  const onInputChange = async value => {
    if (fieldType == "MultiSelect" || fieldType == "SimpleSelect" || fieldType == "RelationStatic" || fieldType == "RelationListStatic") {
      setInputVal(value)
    }
    else {
      setLoading(true)
      setInputVal(value)
      var response = await fetchSuggestions(props, value, false)
      //unwrapped used here essentially to type assert.
      var unwraped = unwrapSuggestions(response)
      setLoading(false)
      setOptions(unwraped);
    }

  };

  const probeOptions = async value => {
    setasUrl(props.autoSuggestURL)
    if (props.fieldDefinition.probeAutoSuggestURL) {
      var response = await fetchSuggestions(props, value, true)
      var unwraped = unwrapSuggestions(response)
      if (unwraped.length > 0) {
        setProbeValid(true)
      }
      if (unwraped.length == 1 && !fieldDefinition.suppressAutoSelection) {
        if (fieldType == "Relation" || fieldType == "RelationStatic") {
          props.onDirectUpdate(unwraped[0])
        } else if (fieldType == "RelationList" || fieldType == "RelationListStatic") {
          props.onDirectUpdate({ relations: unwraped })
        }

      }
      setOptions(unwraped);
    }
  }

  // Pushes the newly selected item data back to up the parent (Definition Section via Form Def Field)
  // Case switch allows for formatting the data based on how the Definition Section expects it, i.e. Relation Object, Pipe Deliniated String, etc. 
  const onChangeHandleToParent = async val => {
    // setInputVal("")
    switch (fieldType) {
      case 'RelationStatic':

        if (props.fieldDefinition.relationType) {
          if (val) {
            val.type = props.fieldDefinition.relationType
          }
        }

        props.onDirectUpdate(val)
        break
      case 'Relation':
        setOptions([])

        if (props.fieldDefinition.relationType) {
          if (val) {
            
            val.type = props.fieldDefinition.relationType
          }
        }


        props.onDirectUpdate(val)
        break;
      case 'RelationListStatic':

        if (props.fieldDefinition.relationType) {
          if (val && val.length > 0) {
            val = val.map((v) => {
              v.type = props.fieldDefinition.relationType
              return v
            })
          }
        }

        props.onDirectUpdate({ relations: val })

        break;
      case 'RelationList':
        setOptions([])

        if (props.fieldDefinition.relationType) {
          if (val && val.length > 0) {
            val = val.map((v) => {
              v.type = props.fieldDefinition.relationType
              return v
            })
          }
        }

        props.onDirectUpdate({ relations: val })
        break;

      case 'MultiSelect':
        if (props.fieldDefinition.freeSolo && val && val[val.length-1] && !val[val.length-1].value) {
          var labelVal = cloneDeep(val[val.length-1])
          val[val.length-1] = {label: labelVal, value: labelVal}
        }
        
        var valArray = unwrapValues(val)
        props.onDirectUpdate(valArray.join('|'))
        break;

      default:

        if (val && val.value) {
          props.onDirectUpdate(val.value)
        } else if (!val) {
          props.onDirectUpdate(null)
        } else if (props.fieldDefinition.freeSolo) {
          props.onDirectUpdate(val)
        }
    }

  };

  // Very simple function used to conditionally not render the chips in the TextField.
  const nullRender = () => {
    null
  }

  // initial options probe.
  React.useEffect(probeOptions, [])

  // if the autoSuggestURL changes, check to see if we should probe. 
  if (asUrl && (asUrl != props.autoSuggestURL)) {
    probeOptions("")
  }

  const hasItemIdChanged = useCompare(props.data);
  React.useEffect(() => {
    if (!probeValid && hasItemIdChanged) {
      var newOptions = filterConditionalOptions(props.fieldDefinition.options, props)
      if (!newOptions) {

        newOptions = []
      }
      setOptions(newOptions);
    }
  });




  // This use effect reevaluated conditional options and changes the options if they come back different
  React.useEffect(() => {
    // Only applies to single select and multiselect, and will break relation fields if allowed to run rampant. 
    if (fieldType == "MultiSelect" || fieldType == "SimpleSelect") {
      var newOptions = filterConditionalOptions(props.fieldDefinition.options, props)
      if (!newOptions) {

        newOptions = []
      }
      // Checks if the new options are the same as the old options
      var isSame = (newOptions.length == options.length) && newOptions.every(function (element, index) {
        return element === options[index];
      });

      if (!isSame && !probeValid) {
      // if (!isSame ) {
        setOptions(newOptions);
      }
    }
  });



  // The new method for listening for changes. Serves as a componentDidMount AND a componenetWillReceiveProps. 
  React.useEffect(() => {
    if (true) {
      switch (fieldType) {
        case 'RelationStatic':
        case 'Relation':
          setValue(props.value);
          break;

        case 'RelationListStatic':
        case 'RelationList':
          if (!props.value || props.value == "") {
            if (value.length != 0) {
              setValue([]);
            }
          } else {
            if (props.value && props.value.relations) {
                setValue(props.value.relations);
            }
          }


          break;

        case 'MultiSelect':

          if (!props.value || props.value == "") {
            if (value.length != 0) {
              setValue([]);
            }
          } else {

            var valueStrings = props.value.split('|')

            var optionValues = []
            for (var vString of valueStrings) {
              var foundOption = false
                for (var option of options) {
                  if (option.value == vString) {
                    foundOption = true
                    optionValues.push(option)
                  }
                }

                if (!foundOption && props.fieldDefinition.freeSolo) {
                  optionValues.push({label: vString, value: vString})
                } 

            }

            if (optionValues.length != value.length) {
              setValue(optionValues);
            }
          }
          break;

        // Standard Single Select
        default:
          var optionValue = null
          var foundOption = false
          for (var option of options) {
            if (option.value == props.value) {
              foundOption = true
              optionValue = option
            }
          }
        
          if (!foundOption && props.value && props.value != "" && props.fieldDefinition.freeSolo) {
            optionValue = {label: props.value, value: props.value}
          }

          if (!isEqual(optionValue, value)) {
            setValue(optionValue);
          }

      }
    }
  });

  var fieldDefinition = props.fieldDefinition



  var placeholder = ''
  if (fieldType == "Relation" || fieldType == "RelationList") {
    placeholder = "Start typing for suggestions"
  }

  if (fieldDefinition && fieldDefinition.placeholder && fieldDefinition.placeholder != "") {
    placeholder = fieldDefinition.placeholder
  }

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  // FILTERING OUT ALREADY SELECTED ITEMS FOR RELATION LIST
  var filteredOptions = options
  if (fieldType == "RelationList" || fieldType == "RelationListStatic") {
    for (var v of value) {
      filteredOptions = filteredOptions.filter((o) => o.label !== v.label)
    }
  }

  const styleObj = props.fieldDefinition.styleAttributes;


  var minQueryChars = fieldDefinition.minQueryChars || 2

  var noOptionsText = ""


  // Reoriented this a little bit to provide better feedback to the user. JD 2020-09-22
  if (inputVal.length >= minQueryChars) {
    if (inputVal.length > 0) {
      if (!loading) {
        noOptionsText = "No options found"
      } else {
        noOptionsText = "Loading..."
      }
    }

  } else {
    if (fieldType == "Relation" || fieldType == "RelationList") {
      noOptionsText = "At least " + minQueryChars + " character(s) must be entered"
    }
  }


  var randID = makeid(10)
  var fullID = fieldDefinition.key + randID
  var chipsVariant = false
  if (fieldDefinition.variant && fieldDefinition.variant == "Chips") {
    chipsVariant = true
  }
  
  var probeDisplayMode = probeValid && options.length == 1 && !fieldDefinition.suppressAutoSelection && (props.fieldDefinition.mode == "Required" || props.fieldDefinition.mode == "Optional")
  // We have to use a custom popper to pass in the fit-content path to make the list items match the width of the label and not the field
  const CustomPopper = function (props) {
    return <Popper {...props} style={{ width: "fit-content" }} placement="bottom-start" />;
  };
  
  // If chipAttributes is set with a threshold, if the number of items in the list is greater, the user will be able to highlight matches
  var showFilterThreshold = 0
  if (props && props.fieldDefinition && props.fieldDefinition.chipAttributes && props.fieldDefinition.chipAttributes.showFilterThreshold) {
    showFilterThreshold = Number.parseInt(props.fieldDefinition.chipAttributes.showFilterThreshold || 0)
  }

  var renderTags;
  if ((fieldType == "RelationList" || fieldType == "RelationListStatic") && !chipsVariant && nullRender) {
    // This is when we DON'T want to use the in-line chips
    renderTags = nullRender
  }


  return (
    <FormControl
      disabled={props.disabled || props.readOnly || probeDisplayMode}
      required={props.fieldDefinition.variant != "Question" && props.fieldDefinition.mode == "Required"}
      open={open}
      style={styleObj}
      loading={loading.toString()}
      className={props.className}
      error={props.error}>
      <Autocomplete
        // disablePortal
        id={fullID}
        name={props.fieldDefinition.key}
        className={props.className}
        PopperComponent={CustomPopper}
        autoHighlight={true}
        freeSolo={props.fieldDefinition.freeSolo}
        // autoHighlight={fieldType != "RelationList"}
        multiple={fieldType == "MultiSelect" || fieldType == "RelationList" || fieldType == "RelationListStatic"}
        disableCloseOnSelect={fieldType == "MultiSelect"}
        ChipProps={{ size: "small" }}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        disableListWrap
        disabled={props.disabled || props.readOnly || probeDisplayMode}
        noOptionsText={noOptionsText}
        error={props.error}
        forcePopupIcon={fieldType == "SimpleSelect" || fieldType == "MultiSelect" || fieldType == "RelationStatic" || fieldType == "RelationListStatic"}
        options={filteredOptions}
        value={value}
        required={props.fieldDefinition.mode == "Required"}
        renderOption={(props, option, { selected }) => {
          const suggestionRenderer: any = Renderers.find(fieldDefinition.suggestionRenderer)
          if (suggestionRenderer) {
            var S = suggestionRenderer
            return (
              <li {...props}>
                <S data={option} selected={selected} />
              </li>
            )
          }
          return (
            <li {...props}>
              {fieldType == "MultiSelect" &&
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ margin: 0, marginRight: 8, padding: 0 }}
                  checked={selected}
                />}
              {option.label}
            </li>
          )
        }}
        sx={{ width: 300 }}
        // renderTags={(fieldType == "RelationList" || fieldType == "RelationListStatic") && !chipsVariant && nullRender}
       


        // renderTags={(value:any, getTagProps:any)=>{
        //     if ((fieldType == "RelationList" || fieldType == "RelationListStatic") && !chipsVariant && nullRender) {
        //       return nullRender
        //     } else {
        //       return undefined
        //     }
        //   }
        // }
        renderTags={renderTags}



        onChange={(ev, val) => {
          
          if (ev.code != "Backspace"){
            setValue(val)
            // If the user clicks the 'X' to clear the field, do not propagate changes to parent to prevent chips from clearing
            if (fieldType == "RelationList" || fieldType == "RelationListStatic") {
              if ((ev.currentTarget.classList || {value:''}).value.indexOf('MuiAutocomplete-clearIndicator') < 0 || chipsVariant) {
                
                onChangeHandleToParent(val);
              } else {
                // This would typically hapen in onChangeHandleToParent
                setOptions([])
              }
            } else {
              onChangeHandleToParent(val);
            }
          }
        }}
        renderInput={params => {
          const inputProps = params.inputProps;
          inputProps.autoComplete = navigator.userAgent.indexOf("Chrome") > -1 ? "new-password" : "off";
          
          var keyFieldIcon
          if (props.fieldDefinition.mode == "Key Field") {
            keyFieldIcon = <i style={{color: "#CD5C5C", marginLeft: 5}} className="fa fa-key"></i>
          }

          var fieldInfoIcon
          if (props.fieldDefinition.fieldInfo) {
            fieldInfoIcon = (
              <div style={{display: "inline-block"}}><Poptart
                click={true}
                className="form-def-field-info"
                placement={props.fieldDefinition.fieldInfo.popperPlacement || "top"}
                icon={`fa ${props.fieldDefinition.fieldInfo.icon || "fa-question-circle"}`}
                timeout={350}
                iconStyle={{
                  display: "inline-block",
                  marginLeft: 5
                }}
              >
                <div  style={{width: props.fieldDefinition.fieldInfo.popperWidth, padding: 5}} dangerouslySetInnerHTML={{__html: props.fieldDefinition.fieldInfo.content}}></div>
              </Poptart></div>
            )
          }
    
          return (<TextField
            {...params}
            placeholder={placeholder}
            inputProps={inputProps}
            error={props.error}
            InputLabelProps={{ shrink: true, required: props.fieldDefinition.variant != "Question" && props.fieldDefinition.mode == "Required" }}
            onKeyDown={(ev) => {
              if (ev.code == "Tab" ) {
                // If we want the user to be able to tab through, we need to send an enter key event to the input field
                // before we allow the tab to happen. This will allow the user to tab through the options. selecting the first option
                // if there is no valid option, it will revert to the original value.
                ev.target.dispatchEvent(new KeyboardEvent('keydown', {code: 'Enter', key: 'Enter', keyCode: 13, bubbles: true}))
              }

            }}

            onChange={ev => {
              if (ev.target.value !== "" || ev.target.value !== null) {
                
                onInputChange(ev.target.value);
              }
            }}
            onClick={(evt: any)=>{
              // allows the field info icon to be clicked, otherwise the input field will just be focused.
              if (evt.target.classList.contains('form-def-field-info')) {
                evt.stopPropagation()
              }
            }}
            onBlur = {()=>{
              // This will reset the noOptionsText originally reported in USF-1598
              if (fieldType == "Relation" || fieldType == "RelationList") {
                setInputVal("")
              }
            }}
            InputProps={{
              ...params.InputProps,
              autoComplete: navigator.userAgent.indexOf("Chrome") > -1 ? "new-password" : "off",
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {showFilterThreshold > 0 && value.length > (showFilterThreshold - 1) && <i style={{color: chipFilterElement != null ? 'green' : 'black', position: 'absolute', right: -15, cursor: 'pointer'}} onClick={(evt:any)=>{
                    evt.target._Target = randID
                    if (chipFilterElement != null) { 
                      var o = {
                        target: {value: '', attributes: {
                            "data-target": {"nodeValue": randID}
                          }
                        }
                      }
                      highlight(o);
                      setChipFilterElement(null);
                    } else {
                      setChipFilterElement(evt.target)
                    }
                  }} 
                    className="fa fa-filter"
                   />}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              )
            }}
            label={<div style={{display: "inline-block"}}>{props.title}{keyFieldIcon}{fieldInfoIcon}</div>} />)
        }}
      />
      
      {props.helpText && props.helpText != "" && <FormHelperText>{props.helpText}</FormHelperText>}
      {(fieldType == "RelationList" || fieldType == "RelationListStatic") && !chipsVariant && <Box ref={sectionContainerRef}
        className={randID+"_Container"}
        mt={1}
        sx={{
          "& .MuiChip-root": { margin: 0.5 },
        }}
      >
        {value && (fieldType == "RelationList" || fieldType == "RelationListStatic") && value.map((v) => (
          <Chip key={v.label} label={v.label} title={v.label} disabled={props.disabled || props.readOnly || probeDisplayMode} onDelete={onListDelete(v.label)} />
        ))}
      </Box>}
      <Popper style={{marginBottom: 5}} placement="top-end" anchorEl={chipFilterElement} open={chipFilterElement != null} >
        <Box style={{borderColor: '#b5b5b5', borderRadius: 7, marginBottom: 5}} sx={{ border: 1, p: 1, bgcolor: '#eff1f2' }}>
          <input data-target={randID} placeholder="Enter filter text" autoFocus={true} type="text" onKeyDown={(evt:any)=>{
            if (evt && evt.keyCode == 27) {
              var o:any = {
                target: {value: '', attributes: {
                  "data-target": {"nodeValue": randID}
                }
              }}
              highlight(o);
              setChipFilterElement(null);
            }
          }} onChange={highlight} style={{outline: 'none', border: 'none', borderBottom: '1px solid #b5b5b5',  height: 30, width: 250, marginTop: 2, borderRadius: 4, paddingLeft: 10}}  />
        </Box>
      </Popper>
    </FormControl>
  );
}

